export default {
    HIOPOSWEBSERVICES: 'https://hiopos-lab.saas.com.co',
    HIOPOSREPORTS: 'https://hioposreports-lab.saas.com.co',
  }
  